import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { skinColorOptions, skinGradientOptions, skinInfectionOptions, skinMoistureOptions, skinTempratureOptions, skinTexttureOptions } from './formFootOptions';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm'; 


const SkinAssesment = (props) => {
    const {control, errors, getValues} = props

    const skin_assesment_form = [
        {labelName:"Temperature",field_name: "skin_assesment.temperature", option:skinTempratureOptions },
        {labelName:"Colour",field_name: "skin_assesment.color", option:skinColorOptions },
        {labelName:"Skin texture",field_name: "skin_assesment.texture", option:skinTexttureOptions },
        {labelName:"Skin moisture",field_name: "skin_assesment.moisture", option:skinMoistureOptions },
        {labelName:"Temp gradient ",field_name: "skin_assesment.gradient", option:skinGradientOptions },
    ]

  return (
    <ParentContainerSection heading="Section F – Assessment of the skin of the lower leg and foot">
            {skin_assesment_form.length && skin_assesment_form.map((item,index)=>(
              <InputContainer key={`${item.field_name + index}`}>
          <CustomInputLable required>{item.labelName}</CustomInputLable>
                <RadioButtonController
                                name={item.field_name}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={item.option}
                                isDisabled
                            />
                </InputContainer>
        ))}
        <InputContainer >
          <CustomInputLable>Skin Infection</CustomInputLable>
        <CheckboxController
                                name="skin_assesment.infection"
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                options={skinInfectionOptions}
                                isDisabled
                                isCustomPadding
                            />
                            </InputContainer>
            </ParentContainerSection>
  )
}

export default SkinAssesment